import React from 'react';
import PageMeta from '../components/common/PageMeta';
import Navbar from '../layout/Header/Navbar';
import Layout from '../layout/Layout';
import AboutPageHero from "../components/onlinePayments/AboutPageHero";
import Footer from "../components/Home/Footer";
import IntegrationOptions from "../components/onlinePayments/IntegrationOptions";
import Benefits from "../components/onlinePayments/Benefits";

const UseCases = () => {
  return (
    <Layout>
      <PageMeta title='About us - Sunlex' />
      <Navbar classOption='navbar-light' />
      <AboutPageHero />
      <IntegrationOptions />
      <Benefits />
      <Footer />
    </Layout>
  );
};

export default UseCases;
